import ToastPopup from '../../HelperClasses/AppLoaderClasses/ToastPopup';

export const checkAccountForm = ({form_data, attributes, attributeData}) => {
  if (
    form_data?.name === '' ||
    form_data?.name?.replace(/\s/g, '').length <= 0
  ) {
    ToastPopup({type: 'error', message: 'Name is required'});
    return false;
  }
  if (
    form_data?.user_id === '' ||
    form_data?.user_id?.replace(/\s/g, '').length <= 0
  ) {
    ToastPopup({type: 'error', message: 'User is required'});
    return false;
  }

  if (attributes?.length > 0) {
    for (let i = 0; i < attributes.length; i++) {
      const attribute = attributes[i];
      if (!attribute.optional) {
        if (
          !attributeData?.filter(at_data => at_data.id === attribute.id)
            ?.length > 0 ||
          attributeData === null
        ) {
          ToastPopup({type: 'error', message: `${attribute.name} is required`});
          return false;
          return false;
          break;
        }
      }
    }
  }

  return true;
};
